import React, { useEffect, useState, useContext } from "react";
import "./Blog_Banner.css";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookmark,
  faShareNodes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { BlogById } from "../../../../utils/apis/blog/Blog";
import { Context } from "../../../../utils/context";
import { IDS } from "../../../../utils/common";

const Blog_Banner = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { IMG_URL } = useContext(Context);

  const [blogbanner, setBlogBanner] = useState({});

  console.log(blogbanner.createdAt, "Date");

  const getBlogBanner = async () => {
    const res = await BlogById(id);

    if (res?.success) {
      setBlogBanner(res?.data || {});
    }
  };

  useEffect(() => {
    if (id) {
      getBlogBanner();
    }
  }, [id]);

  return (
    <section className="Blog_Banner residential_service">
      <div className="container">
        {/* <div className="breadcrumb_wrapper">
          <span className="breadcrumb_link" onClick={() => navigate("/")}>
            Home
          </span>

          <span className="breadcrumb_separator"> &gt; </span>

          <span className="breadcrumb_link" onClick={() => navigate("/blog")}>
            Blog
          </span>

          <span className="breadcrumb_separator"> &gt; </span>

          <span className="breadcrumb_active">{blogbanner?.title}</span>
        </div> */}

        <div className="blog_banner_div">
          <img
            src={IDS?.IMG_URL + blogbanner?.image}
            style={{ height: "500px", width: "1550px" }}
            alt="blog-banner"
            className="blog_img"
          />

          <div className="blog_banner_overlay">
            <div className="blog_banner_author_holder">
              <div className="profile_icon_holder">
                <FontAwesomeIcon icon={faUser} style={{ color: "#666666" }} />
              </div>

              <span className="author_name">{blogbanner?.name}</span>

              <span className="banner_date">
                -{" "}
                {new Date(blogbanner.createdAt).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            </div>

            <div className="blog_banner_title_div">
              <h2 className="blog_banner_title">{blogbanner?.title}</h2>

              <div className="save_icon_div">
                {/* <div className="save_icon_holder">
                  <FontAwesomeIcon icon={faShareNodes} className="font_icon" />
                  <p className="icon_text">share</p>
                </div> */}

                {/* <div className="save_icon_holder">
                  <FontAwesomeIcon icon={faBookmark} className="font_icon" />
                  <p className="icon_text">save</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog_Banner;
